class Environment {
  // constructor() {
  //   console.log(this.publicKey());
  // }

  getLocalBasePath(): string {
    return process.env.REACT_APP_LOCAL_BASE_PATH!;
  }

  apiUrl(path: string) {
    // const base = this.ttsBaseApiUri();
    //   return `${base}${path}`;
    if (path.startsWith(process.env.REACT_APP_API_BASE_URL!)) {
      return path;
    }
    return process.env.REACT_APP_API_BASE_URL + path;
  }

  publicKey() {
    return process.env.REACT_APP_PUBLIC_KEY_ENCRYPT!;
  }
}

export default Environment;
